/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from "react"
import MediaQuery from "react-responsive"

import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
import favicon from "../assets/favicon.png"

import NavigationMobile from "./Navigation/navigationMobile"
import Navigation from "./Navigation/navigation"
import Footer from "./Footer/footer"

import "./layout.scss"
import "../ext"

if (typeof window !== "undefined") {
  // eslint-disable-next-line global-require
  require("smooth-scroll")('a[href*="#"]', {
    offset: 100,
  })
}

const Layout = props => {
  return (
    <>
      <Helmet>
        <link rel="shortcut icon" type="image/jpg" href={favicon} />
        <link
          href="https://fonts.googleapis.com/css?family=Open+Sans+Condensed:700|Open+Sans:400,600,700|Saira+Condensed:700&display=swap"
          rel="stylesheet"
        />
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/Swiper/4.5.0/css/swiper.min.css"
        />
      </Helmet>
      <MediaQuery maxWidth={991}>
        <NavigationMobile active_navigation={props.active_navigation} />
      </MediaQuery>
      <MediaQuery minWidth={992}>
        <Navigation active_navigation={props.active_navigation} />
      </MediaQuery>
      <main>{props.children}</main>
      <Footer />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
